import { Blockquote } from "@tiptap/extension-blockquote"
import { Bold } from "@tiptap/extension-bold"
import { Code } from "@tiptap/extension-code"
import { CodeBlock } from "@tiptap/extension-code-block"
import { Document } from "@tiptap/extension-document"
import { HardBreak } from "@tiptap/extension-hard-break"
import { Heading } from "@tiptap/extension-heading"
import { Highlight } from "@tiptap/extension-highlight"
import { HorizontalRule } from "@tiptap/extension-horizontal-rule"
import { Italic } from "@tiptap/extension-italic"
import { Link } from "@tiptap/extension-link"
import { BulletList, ListItem, OrderedList, TaskItem, TaskList } from "@tiptap/extension-list"
import { Paragraph } from "@tiptap/extension-paragraph"
import { Strike } from "@tiptap/extension-strike"
import { Subscript } from "@tiptap/extension-subscript"
import { Superscript } from "@tiptap/extension-superscript"
import { Text } from "@tiptap/extension-text"
import { TextAlign as TextAlignExtension } from "@tiptap/extension-text-align"
import { Color, FontSize, LineHeight, TextStyle } from "@tiptap/extension-text-style"
import { Underline } from "@tiptap/extension-underline"
import { Dropcursor, Focus, TrailingNode, UndoRedo } from "@tiptap/extensions"

import { HeadingLevel, TextAlign } from "./enums"
import {
	AssetMention,
	AssetTypeMention,
	DocumentLinkNode,
	DocumentMention,
	FormMention,
	FormSubmissionMention,
	GeoImageMention,
	IssueLinkNode,
	IssueMention,
	IssueTypeMention,
	UserMention,
} from "./nodes"

import styles from "./Tiptap.module.css"

export const TEXT_ALIGNMENTS: TextAlign[] = [TextAlign.LEFT, TextAlign.CENTER, TextAlign.RIGHT, TextAlign.JUSTIFY]

export const HEADING_LEVELS: HeadingLevel[] = [
	HeadingLevel.H1,
	HeadingLevel.H2,
	HeadingLevel.H3,
	HeadingLevel.H4,
	HeadingLevel.H5,
]

export const BASE_EXTENSIONS = [
	// Nodes
	Document,
	Blockquote.configure({
		HTMLAttributes: {
			class: styles.Blockqoute,
		},
	}),
	BulletList.configure({
		HTMLAttributes: {
			class: styles.BulletList,
		},
	}),
	CodeBlock.configure({
		HTMLAttributes: {
			class: styles.CodeBlock,
		},
	}),
	HardBreak,
	Heading.configure({
		HTMLAttributes: {
			class: styles.Heading,
		},
		levels: HEADING_LEVELS,
	}),
	HorizontalRule.configure({
		HTMLAttributes: {
			class: styles.HorizontalRule,
		},
	}),
	ListItem,
	OrderedList.configure({
		HTMLAttributes: {
			class: styles.OrderedList,
		},
	}),
	Paragraph.configure({
		HTMLAttributes: {
			class: styles.Paragraph,
		},
	}),
	Text,
	TaskList.configure({
		HTMLAttributes: {
			class: styles.TaskList,
		},
	}),
	TaskItem.configure({
		nested: true,
		HTMLAttributes: {
			class: styles.TaskItem,
		},
	}),

	// Marks
	Bold,
	Code.configure({
		HTMLAttributes: {
			class: styles.Code,
		},
	}),
	Italic,
	Link.configure({
		HTMLAttributes: {
			class: styles.Link,
		},
	}),
	Strike,
	Subscript,
	Superscript,
	TextStyle,
	Underline,
	Highlight.configure({
		multicolor: true,
	}),

	// Functionality
	Color,
	FontSize,
	LineHeight,
	TextAlignExtension.configure({
		types: ["heading", "paragraph"],
		alignments: TEXT_ALIGNMENTS,
	}),
	Focus,
	UndoRedo,
	TrailingNode,
	Dropcursor,
] as const

export const LINK_NODES = [IssueLinkNode, DocumentLinkNode] as const

export const MENTION_EXTENSIONS = [
	AssetMention,
	AssetTypeMention,
	DocumentMention,
	FormMention,
	FormSubmissionMention,
	GeoImageMention,
	IssueMention,
	IssueTypeMention,
	UserMention,
] as const
